module.exports = __webpack_public_path__ + "static/media/winZoleAll_1.d13a20a2.svg";